import { useState } from "preact/hooks";
import { getHistory, clearHistory, type HistoryEntry } from "./api.ts";
import { appStore } from "./store.ts";

function formatTime(ms: number): string {
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${m}:${String(s).padStart(2, "0")}`;
}

function formatDate(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function HistoryView() {
  const [entries, setEntries] = useState<HistoryEntry[]>(() =>
    getHistory().sort((a, b) => b.timestamp - a.timestamp)
  );

  function handleClear() {
    clearHistory();
    setEntries([]);
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h3 style={{ margin: 0 }}>Watch History</h3>
        {entries.length > 0 && (
          <button
            onClick={handleClear}
            style={{ padding: "6px 14px", fontSize: "13px" }}
          >
            Clear History
          </button>
        )}
      </div>

      {entries.length === 0 ? (
        <p style={{ color: "#888" }}>No watch history yet.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {entries.map((entry) => (
            <div
              key={entry.url}
              onClick={() => appStore.getState().playFromHistory(entry)}
              style={{
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              <div style={{ fontWeight: "bold", marginBottom: "4px", wordBreak: "break-word" }}>
                {entry.title ? decodeURIComponent(entry.title) : entry.url}
              </div>
              <div style={{ fontSize: "13px", color: "#666", display: "flex", justifyContent: "space-between" }}>
                <span>
                  {formatTime(entry.positionMs)} / {formatTime(entry.durationMs)}
                </span>
                <span>{formatDate(entry.timestamp)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
